import React from "react";
import { StationIssue } from "@shared/models";
import { getFormattedDate } from "@shared/utils";
import { DATE_FORMAT_TYPE } from "@shared/interfaces";

import "./index.scss";

interface StationIssueRowComponentProps {
  item: StationIssue;
  onClickMarkAsRead: (issue: StationIssue) => void;
  onOpen: (issue: StationIssue) => void;
}

const StationIssueRowComponent = (props: StationIssueRowComponentProps) => {
  const { item, onClickMarkAsRead, onOpen } = props;
  return (
    <div className="sdh-issue-row" title={`${item.patient?.last_name} ${item.patient?.first_name}`}>
      <div className="sdh-issue-row-name-wrapper">
        <div className="sdh-issue-row-name" onClick={onOpen.bind(this, item)}>
          {item.patient?.last_name} {item.patient?.first_name}
        </div>
        <div className="sdh-issue-row-code">{item.station.station_code}</div>
      </div>
      <div className="sdh-issue-data-wrapper">
        <div className="sdh-issue-reason">{item.issue}</div>
        <div className="sdh-issue-date">Since {getFormattedDate(item.issue_date, DATE_FORMAT_TYPE.SHORT)}</div>
      </div>
      <div className="sdh-issue-data-wrapper sdh-issue-data-read">
        <div className="sdh-issue-data-read-btn" onClick={onClickMarkAsRead.bind(this, item)}>
          Read
        </div>
      </div>
    </div>
  );
};

export default StationIssueRowComponent;
